import script from "./StarRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=3f70fcf5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f70fcf5"]])

export default __exports__